// Words typed into a box but not sent yet (a picture's description, a line's words and direction, an animation's
// description). They are kept here, by the item and the box, so they are still there after switching to another stage
// of the item and back, or closing the page and opening it again. They last until the app is reloaded.
// Without a key the box is an ordinary one and forgets its words when the page goes.
import { useCallback, useState } from "react";

const g = globalThis as { sketchyDrafts?: Map<string, string> };
const typed = (g.sketchyDrafts ??= new Map()); // kept on globalThis so a reload of the app's code keeps them

// Like useState for a text box. `key` names the item and the box ("picture:p1:words"); `initial` is used the first time.
export function useDraft(key: string | undefined, initial = ""): [string, (text: string) => void] {
  const [text, setText] = useState(() => (key !== undefined && typed.has(key) ? typed.get(key)! : initial));
  const set = useCallback((next: string) => {
    if (key !== undefined) typed.set(key, next);
    setText(next);
  }, [key]);
  return [text, set];
}
